function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.2531 30.9723C30.0135 33.325 26.7119 34.5128 23.4333 35.4493C20.1316 36.3629 16.8531 37.0025 13.5745 36.4772C10.296 35.9518 7.01741 34.2387 5.23959 31.5662C3.46176 28.9165 3.18469 25.3076 3.39248 21.8585C3.62337 18.4094 4.38531 15.143 6.34782 13.0188C8.28724 10.8945 11.4735 9.93512 14.8906 8.06211C18.3308 6.16627 22.048 3.37959 25.7653 3.3339C29.4594 3.28822 33.1767 6.00637 35.0468 9.52398C36.8939 13.0416 36.917 17.3587 36.3167 21.2646C35.7164 25.1705 34.5158 28.6425 32.2531 30.9723Z",
  fill: "#E9FAF5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.6182 10.6522V11.2522H25.2182H30.4153V28.6029H9.58631V11.2522H14.7834H15.3834V10.6522V8.93333H24.6182V10.6522Z",
  stroke: "#676F8F",
  strokeWidth: 1.2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.603 19.82H22.5061C22.8446 19.82 23.1191 20.0818 23.1191 20.4047V28.5901C23.1191 28.913 22.8446 29.1748 22.5061 29.1748H17.603C17.2645 29.1748 16.9901 28.913 16.9901 28.5901V20.4047C16.9901 20.0818 17.2645 19.82 17.603 19.82Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1174 20.4652H21.9883C22.2555 20.4652 22.4722 20.7089 22.4722 21.0096V28.6305C22.4722 28.9311 22.2555 29.1748 21.9883 29.1748H18.1174C17.8501 29.1748 17.6335 28.9311 17.6335 28.6305V21.0096C17.6335 20.7089 17.8501 20.4652 18.1174 20.4652Z",
  fill: "#B6EFDD"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7626 13.046H15.2408C15.561 13.046 15.8206 13.3055 15.8206 13.6257V17.1039C15.8206 17.4241 15.561 17.6837 15.2408 17.6837H11.7626C11.4424 17.6837 11.1829 17.4241 11.1829 17.1039V13.6257C11.1829 13.3055 11.4424 13.046 11.7626 13.046Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M12.1493 13.7656H14.8105C15.0555 13.7656 15.2541 13.9461 15.2541 14.1688V16.5881C15.2541 16.8108 15.0555 16.9914 14.8105 16.9914H12.1493C11.9043 16.9914 11.7057 16.8108 11.7057 16.5881V14.1688C11.7057 13.9461 11.9043 13.7656 12.1493 13.7656Z",
  fill: "#1ECD96"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M24.6659 13.0457H28.1441C28.4643 13.0457 28.7239 13.3053 28.7239 13.6254V17.1037C28.7239 17.4239 28.4643 17.6834 28.1441 17.6834H24.6659C24.3457 17.6834 24.0861 17.4239 24.0861 17.1037V13.6254C24.0861 13.3053 24.3457 13.0457 24.6659 13.0457Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0526 13.7655H27.7138C27.9588 13.7655 28.1574 13.9461 28.1574 14.1687V16.5881C28.1574 16.8108 27.9588 16.9913 27.7138 16.9913H25.0526C24.8076 16.9913 24.609 16.8108 24.609 16.5881V14.1687C24.609 13.9461 24.8076 13.7655 25.0526 13.7655Z",
  fill: "#1ECD96"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M24.6659 19.82H28.1441C28.4643 19.82 28.7239 20.0796 28.7239 20.3997V23.878C28.7239 24.1982 28.4643 24.4577 28.1441 24.4577H24.6659C24.3457 24.4577 24.0861 24.1982 24.0861 23.878V20.3997C24.0861 20.0796 24.3457 19.82 24.6659 19.82Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0526 20.5398H27.7138C27.9588 20.5398 28.1574 20.7204 28.1574 20.9431V23.3624C28.1574 23.5851 27.9588 23.7656 27.7138 23.7656H25.0526C24.8076 23.7656 24.609 23.5851 24.609 23.3624V20.9431C24.609 20.7204 24.8076 20.5398 25.0526 20.5398Z",
  fill: "#1ECD96"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7626 19.82H15.2408C15.561 19.82 15.8206 20.0795 15.8206 20.3997V23.878C15.8206 24.1981 15.561 24.4577 15.2408 24.4577H11.7626C11.4424 24.4577 11.1829 24.1981 11.1829 23.878V20.3997C11.1829 20.0795 11.4424 19.82 11.7626 19.82Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M12.1493 20.5398H14.8105C15.0555 20.5398 15.2541 20.7203 15.2541 20.943V23.3623C15.2541 23.585 15.0555 23.7656 14.8105 23.7656H12.1493C11.9043 23.7656 11.7057 23.585 11.7057 23.3623V20.943C11.7057 20.7203 11.9043 20.5398 12.1493 20.5398Z",
  fill: "#1ECD96"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M7.2464 28.0433H32.7536C33.0738 28.0433 33.3333 28.3029 33.3333 28.6231V30.9419C33.3333 31.262 33.0738 31.5216 32.7536 31.5216H7.2464C6.92624 31.5216 6.66667 31.262 6.66667 30.9419V28.623C6.66667 28.3028 6.92624 28.0433 7.2464 28.0433Z",
  fill: "#676F8F"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M20.0001 16.5165C21.8063 16.5165 23.2705 15.0523 23.2705 13.246C23.2705 11.4398 21.8063 9.97561 20.0001 9.97561C18.1939 9.97561 16.7296 11.4398 16.7296 13.246C16.7296 15.0523 18.1939 16.5165 20.0001 16.5165Z",
  fill: "#C6CAD5"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M20.0001 16.1538C21.8063 16.1538 23.2705 14.6896 23.2705 12.8833C23.2705 11.0771 21.8063 9.61291 20.0001 9.61291C18.1939 9.61291 16.7296 11.0771 16.7296 12.8833C16.7296 14.6896 18.1939 16.1538 20.0001 16.1538Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M21.9106 12.2413H20.7876C20.7076 12.2413 20.6428 12.1765 20.6428 12.0965V10.9735C20.6428 10.8936 20.578 10.8287 20.498 10.8287H19.5034C19.4234 10.8287 19.3586 10.8935 19.3586 10.9735V12.0966C19.3586 12.1765 19.2938 12.2414 19.2138 12.2414H18.0908C18.0108 12.2414 17.946 12.3062 17.946 12.3862V13.3807C17.946 13.4607 18.0108 13.5255 18.0908 13.5255H19.2138C19.2938 13.5255 19.3586 13.5903 19.3586 13.6703V14.7933C19.3586 14.8733 19.4234 14.9381 19.5034 14.9381H20.498C20.5779 14.9381 20.6428 14.8733 20.6428 14.7933V13.6703C20.6428 13.5904 20.7076 13.5255 20.7876 13.5255H21.9106C21.9905 13.5255 22.0554 13.4607 22.0554 13.3807V12.3862C22.0554 12.3062 21.9905 12.2413 21.9106 12.2413Z",
  fill: "#676F8F"
});

var SvgHospital = function SvgHospital(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHospital, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hospital.63d66840.svg";
export { ForwardRef as ReactComponent };